
import { types, actions } from './requests'
export const GETPICTURE_TYPES = {
    ...types('GETPICTURE'),
}
export const GETPICTURE_ACTIONS = {
    ...actions('GETPICTURE'),
}